import React, { useState } from 'react';
import './TransactionTypeModal.css';
import BulkTransactionEntry from './BulkTransactionEntry';
import BulkTransactionEntry_TransferPayment from './BulkTransactionEntry_TransferPayment';
import { collection, getDocs, query, where, deleteDoc, doc } from 'firebase/firestore';
import { db, auth } from '../../firebase';

function TransactionTypeModal({ onClose }) {
  const [selectedMode, setSelectedMode] = useState(null);
  const [showDraftOptions, setShowDraftOptions] = useState(false);
  const [foundDraft, setFoundDraft] = useState(null);
  const [checkingDraft, setCheckingDraft] = useState(false);
  const user = auth.currentUser;

  const checkForDraft = async (mode) => {
    setCheckingDraft(true);
    try {
      const draftsRef = collection(db, 'users', user.uid, 'Settings', 'WebPage', 'Drafts');
      const q = query(draftsRef, where('mode', '==', mode));
      const snapshot = await getDocs(q);
      
      if (!snapshot.empty) {
        // Get the most recent draft
        const drafts = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        drafts.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
        setFoundDraft(drafts[0]);
        setShowDraftOptions(true);
      } else {
        // No draft found, proceed to new entry
        setSelectedMode(mode);
      }
    } catch (error) {
      console.error('Error checking for draft:', error);
      setSelectedMode(mode);
    } finally {
      setCheckingDraft(false);
    }
  };

  const handleRetrieveDraft = () => {
    setSelectedMode(foundDraft.mode);
    setShowDraftOptions(false);
  };

  const handleNewEntry = () => {
    setSelectedMode(foundDraft.mode);
    setFoundDraft(null);
    setShowDraftOptions(false);
  };

  const handleDeleteDraft = async () => {
    if (window.confirm('Are you sure you want to delete this draft?')) {
      try {
        await deleteDoc(doc(db, 'users', user.uid, 'Settings', 'WebPage', 'Drafts', foundDraft.id));
        alert('Draft deleted successfully');
        setSelectedMode(foundDraft.mode);
        setFoundDraft(null);
        setShowDraftOptions(false);
      } catch (error) {
        console.error('Error deleting draft:', error);
        alert('Error deleting draft: ' + error.message);
      }
    }
  };

  if (selectedMode === 'expense-income') {
    return <BulkTransactionEntry mode={selectedMode} onClose={onClose} draftData={foundDraft} />;
  }

  if (selectedMode === 'transfer-payment') {
    return <BulkTransactionEntry_TransferPayment mode={selectedMode} onClose={onClose} draftData={foundDraft} />;
  }

  if (showDraftOptions && foundDraft) {
    return (
      <div className="type-modal-overlay">
        <div className="type-modal-content">
          <div className="type-modal-header">
            <h2>Pending Draft Found</h2>
            <button className="btn-close" onClick={onClose}>✕</button>
          </div>

          <div className="type-modal-body">
            <p className="type-instruction">
              You have a pending draft for <strong>{foundDraft.mode === 'expense-income' ? 'Expense/Income' : 'Transfer/Payment'}</strong>
            </p>
            <div className="draft-info">
              <p><strong>Created:</strong> {new Date(foundDraft.createdAt).toLocaleString()}</p>
              <p><strong>Last Updated:</strong> {new Date(foundDraft.updatedAt).toLocaleString()}</p>
              <p><strong>Entries:</strong> {foundDraft.rowCount || foundDraft.pairCount || 0} row(s)</p>
            </div>

            <p className="type-instruction">Would you like to retrieve it?</p>

            <div className="draft-options">
              <button className="draft-btn retrieve" onClick={handleRetrieveDraft}>
                <span className="draft-icon">📥</span>
                <h3>Retrieve</h3>
                <p>Continue editing</p>
              </button>

              <button className="draft-btn new-entry" onClick={handleNewEntry}>
                <span className="draft-icon">📝</span>
                <h3>New</h3>
                <p>Start fresh</p>
              </button>

              <button className="draft-btn delete" onClick={handleDeleteDraft}>
                <span className="draft-icon">🗑️</span>
                <h3>Delete Draft</h3>
                <p>Remove permanently</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="type-modal-overlay">
      <div className="type-modal-content">
        <div className="type-modal-header">
          <h2>Add Transactions</h2>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>

        <div className="type-modal-body">
          <p className="type-instruction">Choose transaction type to add:</p>
          
          <div className="type-options">
            <div 
              className="type-card expense-income"
              onClick={() => checkForDraft('expense-income')}
            >
              <div className="type-icon">💰</div>
              <h3>Expense / Income</h3>
              <p>Add regular expenses and income transactions</p>
              <div className="type-examples">
                <span className="badge expense">Expense</span>
                <span className="badge income">Income</span>
              </div>
            </div>

            <div 
              className="type-card transfer-payment"
              onClick={() => checkForDraft('transfer-payment')}
            >
              <div className="type-icon">🔄</div>
              <h3>Transfer / Payment</h3>
              <p>Add transfers between accounts and payments</p>
              <div className="type-examples">
                <span className="badge transfer">Transfer</span>
                <span className="badge payment">Payment</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TransactionTypeModal;